import { COHORTS, useCohort, useLoggedOut } from '@/components/user-context/helpers/cohorts';

import { CurrentProductUser } from './current-product-user';
import { ExistingUser } from './existing-user';
import { LoggedOut } from './logged-out';
import { NewUser } from './new-user';

export const ServiceCollectionSignup = () => {
	const cohort = useCohort();
	const loggedOut = useLoggedOut();

	if (loggedOut) {
		return <LoggedOut />;
	}

	if (!cohort) {
		return null;
	}

	switch (cohort) {
		case COHORTS.MANAGED_USER:
		case COHORTS.WEEK_ONE_USER:
		case COHORTS.CURRENT_PRODUCT_USER:
			return <CurrentProductUser />;
		case COHORTS.NEW_USER:
			return <NewUser />;
		default:
			return <ExistingUser />;
	}
};
